import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';
import DataHeader from './DataHeader';

const Index = ({ batchData }) => {
  const fetchFiibLeaderboard = async () => {
    const res = await axios.get(API_URL + '/batch/batch-user-belong-scores', {
      params: { batchId: batchData._id },
    });
    return res;
  };

  const { status, data } = useQuery(
    `FiibData${batchData._id}`,
    fetchFiibLeaderboard
  );
  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <Typography>Error fetching data</Typography>}
      {status === 'success' && <DataHeader data={data.data.data} />}
    </div>
  );
};

export default Index;
